import { Pipe, PipeTransform } from '@angular/core';
import * as Moment from 'moment';
import { CONFIG } from '../constants/config.constants';

@Pipe({
  name: 'formatAllDateTimePipe'
})
export class FormatAllDateTimePipe implements PipeTransform {
	transform(value: any, type: string): string {
		if (!value) {
			return;
		}

		let formatedDate;
		switch (type) {
			case 'serverDateToClientDate':
				formatedDate = Moment(value, 'DD/MM/YYYY').format(CONFIG.dateFormat);
				break;

			case 'fieldPickerToClientDate':
				const clone = JSON.parse(JSON.stringify(value));
				clone.month--;

				formatedDate = Moment(clone).format(CONFIG.dateFormat);
				break;

			default:
				formatedDate = '';
				break;
		}

		return formatedDate;
	}
}
